import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/seo/SEOHead";
import Brand from "@/components/ui/brand";
import { useTranslation } from "react-i18next";

const Impressum = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead
        title={t("impressum.seoTitle")}
        description={t("impressum.seoDesc")}
        canonical="/impressum"
        noindex
      />
      <Header />

      <main id="main-content" className="flex-1 pt-28 pb-20 section-padding">
        <div className="max-w-2xl mx-auto space-y-10">
          <h1 className="text-headline">{t("impressum.title")}</h1>

          <section className="space-y-2">
            <h2 className="text-subheadline">{t("impressum.s1Title")}</h2>
            <p className="text-body">
              <Brand /><br />
              Alexander Wolfshohl<br />
              Mittelpilghausen 20<br />
              42657 Solingen
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-subheadline">{t("impressum.s2Title")}</h2>
            <p className="text-body">
              {t("common.phone")}: <a href="tel:+4921224355800" className="text-accent hover:underline">0212 24355800</a><br />
              {t("common.email")}: <a href="mailto:kontakt@craftfindus.de" className="text-accent hover:underline">kontakt@craftfindus.de</a>
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-subheadline">{t("impressum.s3Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("impressum.s3Text")}
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-subheadline">{t("impressum.s4Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("impressum.s4Text")}
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-subheadline">{t("impressum.s5Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("impressum.s5Text")}
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Impressum;